export const LEADPOINT_MAPPING  = [
    { fieldName: "Address", fieldMapping: "ADDRESS" },
    { fieldName: "FName", fieldMapping: "FNAME" },
    { fieldName: "LName", fieldMapping: "LNAME" },
    { fieldName: "Email", fieldMapping: "EMAIL" },
    { fieldName: "Phone", fieldMapping: "PRI_PHON" },
    { fieldName: "terms_accepted", fieldMapping: "" },
    { fieldName: "City", fieldMapping: "CITY" },
    { fieldName: "State", fieldMapping: "STATE" },
    { fieldName: "Zip", fieldMapping: "ZIP" },
    { fieldName: "EstimatedHomeValue", fieldMapping: "EST_VAL" },
    { fieldName: "LoanAmount", fieldMapping: "BAL_ONE" },
    { fieldName: "InterestRateLoan1", fieldMapping: "MTG_ONE_INT" },
    { fieldName: "LoanType", fieldMapping: "LOAN_TYPE" },
    { fieldName: "LoanTerm", fieldMapping: "" },
    { fieldName: "CreditRating", fieldMapping: "CRED_GRADE" },
    { fieldName: "CashOut", fieldMapping: "ADD_CASH" },
    { fieldName: "CurrentLoanType", fieldMapping: "" },
    { fieldName: "PropertyType", fieldMapping: "" },
    { fieldName: "VAStatus", fieldMapping: "VA_STATUS" },
    { fieldName: "RoofingType", fieldMapping: "" },
    { fieldName: "RoofingMaterial", fieldMapping: "" },
    { fieldName: "RoofingSteep", fieldMapping: "" },
    { fieldName: "RoofingStories", fieldMapping: "" },
    { fieldName: "HomeOwner", fieldMapping: "" }
] as const;
